import apiCalendarPlan from '@/api/competition'

const state = {
  error: null,
  isLoading: false,
  data: null,
}

export const mutationTypes = {
  getCalendarPlanFilterStart:
    '[filter competition calendar plan] Get competition calendar plan start',
  getCalendarPlanFilterSuccess:
    '[filter competition calendar plan] Get competition calendar plan success',
  getCalendarPlanFilterFailure:
    '[filter competition calendar plan] Get competition calendar plan failure',
}

export const actionTypes = {
  getCalendarPlanFilter:
    '[filter competition calendar plan] Get competition calendar plan',
}

const mutations = {
  [mutationTypes.getCalendarPlanFilterStart](state) {
    state.isLoading = true
    state.data = null
  },

  [mutationTypes.getCalendarPlanFilterSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getCalendarPlanFilterFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getCalendarPlanFilter](context, {id}) {
    context.commit(mutationTypes.getCalendarPlanFilterStart)
    return new Promise((resolve) => {
      apiCalendarPlan
        .competitionCalendarPlansFilterResult(id)
        .then((response) => {
          context.commit(
            mutationTypes.getCalendarPlanFilterSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getCalendarPlanFilterFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
